import React from "react";

import { Col, Flex, Row } from "antd";
import { useHistory } from "react-router-dom";

import "./FormPageLayout.css";
import StyledScrollbar from "../Common/UIComponents/StyledScrollbar";
import { ReactComponent as GenistaLogo } from "../../assets/images/logo/genista-logo.svg";
import { ReactComponent as FlowersIllustration } from "../../assets/images/subscriptions/Flowers.svg";

export default function FormPageLayout({ className, children, addCompany = false }) {
  const history = useHistory();

  return (
    <div className={`FormPageLayout ${className ?? ""}`}>
      {!addCompany && (
      <Row className="FormPageLayout__Header" span={24}>
        <Col flex="auto" offset={1} className="FormPageLayout__Header__Logos">
          <GenistaLogo
            height={32}
            className="FormPageLayout__Header__Logos__Logo"
            onClick={() => history.push("/login")}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                history.push("/login");
              }
            }}
          />
        </Col>
      </Row>
      )}
      <div className="FormPageLayout__Body">
        <FlowersIllustration
          className="FormPageLayout__Flower FormPageLayout__Flower--bottomLeft"
          aria-hidden
        />
        <FlowersIllustration
          className="FormPageLayout__Flower FormPageLayout__Flower--topRight"
          aria-hidden
        />
        <StyledScrollbar
          className="FormPageLayout__ScrollBar"
          noScrollX
          disableTrackYWidthCompensation
          disableTracksWidthCompensation
        >
          <div className="FormPageLayout__BodyInner">
            <div className="FormPageContainer">
              <Flex className="FormPageLayout__Form">
                {children}
              </Flex>
            </div>
          </div>
        </StyledScrollbar>
      </div>
    </div>

  );
}
